import React, { useState, useEffect } from 'react'
import { Text, View, TouchableOpacity, Image, TextInput, ScrollView, Linking } from 'react-native'
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { LinearGradient } from 'expo-linear-gradient';
import styles from './style';
import * as Animatable from 'react-native-animatable'
import { collection, query, where, getDocs, getFirestore, orderBy, addDoc, doc, deleteDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import axios from "axios";

export default function Alineadores({ navigation }) {

    const [retorno, setRetorno] = useState([]);
    const [retorno2, setRetorno2] = useState([]);
    const [url, setUrl] = useState("")
    const [email, setEmail] = useState([]);
    const [email2, setEmail2] = useState("");
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [email3, setEmail3] = useState("");
    const [nome, setNome] = useState("");

    const auth = getAuth();
    const user = auth.currentUser;

    // ---------- Helpers para data via Storage ----------
    const stripParams = (u) => (typeof u === 'string' ? u.split('?')[0] : '');
    const ddmmyyyy = (iso) => {
        if (!iso) return '';
        const d = new Date(iso);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const getDateFromCert = async (certArray) => {
        try {
            if (!Array.isArray(certArray)) return '';
            const firstValid = certArray.find((c) => typeof c === 'string' && c.trim() !== '');
            if (!firstValid) return '';
            const metaUrl = stripParams(firstValid); // https://.../o/Resumos%2Fxxxx
            const res = await fetch(metaUrl); // devuelve JSON de metadatos
            if (!res.ok) return '';
            const meta = await res.json();
            // Esperado: meta.timeCreated = "2025-09-14T19:33:52.500Z"
            return ddmmyyyy(meta.timeCreated);
        } catch (e) {
            console.log('getDateFromCert error:', e);
            return '';
        }
    };
    // ---------------------------------------------------

    const getUrl = async () => {
        const db = getFirestore();
        const citiesRef = collection(db, "Url");
        const q = query(citiesRef, where("url", "!=", ""));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            console.log(doc.id, " => ", doc.data());
            setUrl(doc.data().url)
        });
    }

    const getResumos = async () => {
        const db = getFirestore();
        const citiesRef = collection(db, "Resumos");
        const q = query(citiesRef, where("tipo", "==", "Certificado"), where("diplo", "==", "Alineadores"));
        const querySnapshot = await getDocs(q);

        let array = [];
        querySnapshot.forEach((d) => {
            const data = d.data();
            const Obj = {
                id: d.id,
                email: data.email,
                nome: data.nome,
                diplo: data.diplo,
                telefone: data.telefone,
                pais: data.pais,
                cert: data.cert,
                doc: data.doc,
                grupo: data.grupo,
                // data será calculada por metadatos del Storage
            };
            array.push(Obj)
        });

        // Enriquecer con la fecha proveniente de Storage (timeCreated)
        const withDates = await Promise.all(array.map(async (it) => {
            const fecha = await getDateFromCert(it.cert);
            return { ...it, data: fecha }; // usamos "data" para mostrar en la tabla
        }));

        setRetorno(withDates);
    }

    const getResumos2 = async () => {
        const db = getFirestore();
        const citiesRef = collection(db, "Resumos");
        const q = query(
            citiesRef,
            where("tipo", "==", "Certificado"),
            where("diplo", "==", "Alineadores"),
            where("email", "==", email),
            orderBy("email")
        );

        const querySnapshot = await getDocs(q);
        let array = [];

        querySnapshot.forEach((d) => {
            const data = d.data();
            const Obj = {
                id: d.id,
                email: data.email,
                nome: data.nome,
                diplo: data.diplo,
                telefone: data.telefone,
                pais: data.pais,
                cert: data.cert,
                doc: data.doc,
                grupo: data.grupo,
                // data será calculada por metadatos del Storage
            };
            array.push(Obj)
        });

        const withDates = await Promise.all(array.map(async (it) => {
            const fecha = await getDateFromCert(it.cert);
            return { ...it, data: fecha }; // reutilizamos "data" para mostrar
        }));

        setRetorno2(withDates);
    }

    console.log(retorno)

    useEffect(() => {
        getResumos();
        getUrl();
        if (user !== null) {
            user.providerData.forEach((profile) => {
                setEmail3(profile.email)
            });
        }
    }, [])

    const getNome = async () => {
        const db = getFirestore();
        const citiesRef = collection(db, "Usuarios");
        const q = query(citiesRef, where("email", "==", email3));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((d) => {
            console.log(d.id, " => ", d.data());
            setNome(d.data().nome);
        });
    }

    useEffect(() => {
        getResumos2();
    }, [email])

    useEffect(() => {
        getNome();
    }, [email3])

    useEffect(() => {
        getResumos();
    }, [open])

    // Mantengo por compatibilidad (no usado para Storage)
    function formatFirestoreTimestamp(timestamp) {
        const date = new Date(timestamp.seconds * 1000);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    return (
        <View style={styles.container}>
            <View style={{ flex: 1 }}>
                <View style={styles.header}>
                    <View>
                        <Text style={styles.Title}>Certificados - Alineadores</Text>
                    </View>

                    <TouchableOpacity style={styles.buttomMenu} onPress={() => navigation.goBack()} >
                        <MaterialCommunityIcons
                            name="reply"
                            size={40}
                            color="#ffffff"
                            style={{ justifyContent: 'center', alignContent: 'center' }}
                        />
                    </TouchableOpacity>

                    <View style={{ position: "absolute", top: 30, right: 150 }}>
                        <Text style={{ fontSize: 30, textAlign: 'center', color: "#FFF", fontWeight: "bold" }}>Nº Casos: {retorno.length}</Text>
                    </View>
                    
                    <View style={styles.navBar}>

                        <TouchableOpacity style={styles.NavActive}>
                            <Text style={styles.textNavActive}>Fila</Text>
                        </TouchableOpacity>

                        <TouchableOpacity style={styles.NavDesable} onPress={() => navigation.navigate("AlineadoresAprovados")}>
                            <Text style={styles.textNavDesable}>Aprovados</Text>
                        </TouchableOpacity>
                    </View>
                </View>

                {open === true &&
                    <View>
                        {retorno2 && retorno2.map((item) => {
                            return (
                                <>
                                    <TouchableOpacity style={styles.buttonFechar}
                                        onPress={() => { setOpen(false) }}
                                    >
                                        <Text style={styles.textButtonFechar}>X</Text>
                                    </TouchableOpacity>

                                    <View style={styles.divReturn}>
                                        <Text style={styles.textReturnTitle}>{item.nome}</Text>
                                        <Text style={styles.textReturnEmail}>{item.email}</Text>
                                        <Text style={styles.textReturnEmail2}>{item.diplo}</Text>
                                    </View>

                                    <View style={styles.alinhadorDocs}>
                                        <Text style={styles.textDoc}>Documento:</Text>
                                        <ScrollView horizontal={true}>
                                            {item.doc[0] !== "" &&
                                                <TouchableOpacity style={styles.buttonDoc} onPress={() => { Linking.openURL(item.doc[0]); }}>
                                                    <Text style={styles.textButtonDoc}>📄 Primeira Foto</Text>
                                                </TouchableOpacity>
                                            }
                                            {item.doc[1] !== "" &&
                                                <TouchableOpacity style={styles.buttonDoc} onPress={() => { Linking.openURL(item.doc[1]); }}>
                                                    <Text style={styles.textButtonDoc}>📄 Segunda Foto</Text>
                                                </TouchableOpacity>
                                            }
                                        </ScrollView>
                                    </View>

                                    <View style={styles.alinhadorDocs}>
                                        <Text style={styles.textDoc}>Certificado:</Text>
                                        <ScrollView horizontal={true}>
                                            {item.cert[0] !== "" &&
                                                <TouchableOpacity style={styles.buttonDoc} onPress={() => { Linking.openURL(item.cert[0]); }}>
                                                    <Text style={styles.textButtonDoc}>📄 Primeira Foto</Text>
                                                </TouchableOpacity>
                                            }
                                            {item.cert[1] !== "" &&
                                                <TouchableOpacity style={styles.buttonDoc} onPress={() => { Linking.openURL(item.cert[1]); }}>
                                                    <Text style={styles.textButtonDoc}>📄 Segunda Foto</Text>
                                                </TouchableOpacity>
                                            }
                                        </ScrollView>
                                    </View>

                                    <View style={styles.alinhadorEnviado}>
                                        <View style={styles.alinhadorEnviadoInterno}>
                                            {open2 === false &&
                                                <TouchableOpacity style={styles.buttonProblema} onPress={() => setOpen2(true)}>
                                                    <Text style={styles.textProblema}>Reprovar</Text>
                                                </TouchableOpacity>
                                            }

                                            {open2 === false &&
                                                <TouchableOpacity
                                                    style={styles.buttonEnv}
                                                    onPress={async () => {
                                                        // URL para certificado final
                                                        var encodedUrl = encodeURI(url + item.nome);

                                                        const db = getFirestore();
                                                        const docRef = await addDoc(collection(db, "Resumos"), {
                                                            nome: item.nome,
                                                            email: item.email,
                                                            diplo: item.diplo,
                                                            certificado: encodedUrl,
                                                            telefone: item.telefone,
                                                            pais: item.pais,
                                                            cert: item.cert,
                                                            doc: item.doc,
                                                            grupo: item.grupo,
                                                            tipo: "Concluido",
                                                            // Nuevo campo con fecha formateada
                                                            dataA: item.data || ""  // DD/MM/AAAA desde metadatos
                                                        });

                                                        await deleteDoc(doc(db, "Resumos", item.id));

                                                        axios.post('https://hook.us1.make.com/mr8eo77ek1o2ymviv19pwwut3470jmqi', {
                                                            nome: item.nome,
                                                            email: item.email,
                                                            diplo: item.diplo,
                                                            certificado: encodedUrl,
                                                            telefone: item.telefone,
                                                            pais: item.pais,
                                                            cert: item.cert,
                                                            doc: item.doc,
                                                            grupo: item.grupo,
                                                            status: "✅"
                                                        })
                                                            .then(function (response) {
                                                                console.log(response);
                                                            })
                                                            .catch(function (error) {
                                                                console.error(error);
                                                            });

                                                        setOpen(false)
                                                    }}
                                                >
                                                    <Text style={styles.textEnv}>Aprovar</Text>
                                                </TouchableOpacity>
                                            }

                                            {open2 === true &&
                                                <TouchableOpacity style={styles.buttonProblema} onPress={() => setOpen2(false)}>
                                                    <Text style={styles.textProblema}>Fechar</Text>
                                                </TouchableOpacity>
                                            }
                                        </View>

                                        {open2 === true &&
                                            <>
                                                <TextInput
                                                    style={styles.input}
                                                    placeholder="Motivo de reprovação..."
                                                    placeholderTextColor="#000000"
                                                    type="text"
                                                    multiline={true}
                                                    numberOfLines={4}
                                                    onChangeText={(text) => setEmail2(text)}
                                                    value={email2}
                                                />

                                                <TouchableOpacity
                                                    style={styles.buttonProblema}
                                                    onPress={async () => {
                                                        const db = getFirestore();
                                                        const docRef = await addDoc(collection(db, "Resumos"), {
                                                            nome: item.nome,
                                                            email: item.email,
                                                            diplo: item.diplo,
                                                            telefone: item.telefone,
                                                            pais: item.pais,
                                                            cert: item.cert,
                                                            doc: item.doc,
                                                            grupo: item.grupo,
                                                            tipo: "Reporvado", // mantido como no original
                                                            // Nuevo campo con fecha formateada
                                                            dataA: item.data || "" // DD/MM/AAAA desde metadatos
                                                        });

                                                        await deleteDoc(doc(db, "Resumos", item.id));

                                                        axios.post('https://hook.us1.make.com/mr8eo77ek1o2ymviv19pwwut3470jmqi', {
                                                            nome: item.nome,
                                                            email: item.email,
                                                            diplo: item.diplo,
                                                            telefone: item.telefone,
                                                            pais: item.pais,
                                                            cert: item.cert,
                                                            doc: item.doc,
                                                            grupo: item.grupo,
                                                            status: "❌"
                                                        })
                                                            .then(function (response) {
                                                                console.log(response);
                                                            })
                                                            .catch(function (error) {
                                                                console.error(error);
                                                            });

                                                        setOpen(false)
                                                    }}
                                                >
                                                    <Text style={styles.textProblema}>Enviar</Text>
                                                </TouchableOpacity>
                                            </>
                                        }
                                    </View>
                                </>
                            )
                        })}
                    </View>
                }

                {open === false &&
                    <>
                        <View style={{ flexDirection: 'row', justifyContent: "center", marginTop: 80 }}>
                            <View style={{ backgroundColor: "#FAEDB5", width: 150, height: 60, margin: 5, borderRadius: 15 }}>
                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>Data</Text>
                            </View>
                            <View style={{ backgroundColor: "#FAEDB5", width: 520, height: 60, margin: 5, borderRadius: 15 }}>
                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>Nome do aluno</Text>
                            </View>
                            <View style={{ backgroundColor: "#FAEDB5", width: 500, height: 60, margin: 5, borderRadius: 15 }}>
                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>Email</Text>
                            </View>
                            <View style={{ backgroundColor: "#FAEDB5", width: 150, height: 60, margin: 5, borderRadius: 15 }}>
                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>Diplomado</Text>
                            </View>
                            <View style={{ backgroundColor: "#FAEDB5", width: 150, height: 60, margin: 5, borderRadius: 15 }}>
                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>Grupo</Text>
                            </View>
                            <View style={{ backgroundColor: "#FAEDB5", width: 260, height: 60, margin: 5, borderRadius: 15 }}>
                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>Gerar Certificado</Text>
                            </View>
                        </View>

                        <ScrollView
                            showsVerticalScrollIndicator={false}
                            style={{ marginBottom: 30 }}
                        >
                            {retorno && retorno.map((item) => {
                                return (
                                    <>
                                        <View style={{ flexDirection: 'row', justifyContent: "center", cursor: "crosshair" }}>
                                            <View style={{ backgroundColor: "#EDEDF4", width: 150, height: 60, margin: 5, borderRadius: 15 }}>
                                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>{item.data}</Text>
                                            </View>
                                            <View style={{ backgroundColor: "#EDEDF4", width: 520, height: 60, margin: 5, borderRadius: 15 }}>
                                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>{item.nome}</Text>
                                            </View>
                                            <View style={{ backgroundColor: "#EDEDF4", width: 500, height: 60, margin: 5, borderRadius: 15 }}>
                                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>{item.email}</Text>
                                            </View>
                                            <View style={{ backgroundColor: "#EDEDF4", width: 150, height: 60, margin: 5, borderRadius: 15 }}>
                                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>{item.diplo}</Text>
                                            </View>
                                            <View style={{ backgroundColor: "#EDEDF4", width: 150, height: 60, margin: 5, borderRadius: 15 }}>
                                                <Text style={{ color: "#000", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>{item.grupo}</Text>
                                            </View>
                                            <TouchableOpacity
                                                style={{ backgroundColor: "#5077A1", width: 260, height: 60, margin: 5, borderRadius: 15 }}
                                                onPress={() => { setOpen(true), setEmail(item.email) }}
                                            >
                                                <Text style={{ color: "#fff", textAlign: "center", fontSize: 20, marginTop: 20, fontWeight: "bold" }}>Visualizar e Enviar</Text>
                                            </TouchableOpacity>
                                        </View>
                                    </>
                                )
                            })}
                        </ScrollView>
                    </>
                }
            </View>
        </View>
    )
}
